import { combineReducers } from 'redux';
import app from './app';
import alert from './alert';
import user from './user';
import employee from './employee';
import account from './account';
import shift from './shift';
import holiday from './holiday';
import division from './division';
import attendance from './attendance';
import shiftMaster from './shiftMaster';
import appealRequest from './appealRequest';
import pendingRequest from './pendingRequest';
import testerDevice from './deviceTester';
import userDevice from './userDevice';
import userActivity from './userActivity';
import userAttendance from './userAttendance';
import userLeaveBalance from './userLeaveBalance';
import userLeaveHistory from './userLeaveHistory';

export default combineReducers({
  app,
  alert,
  user,
  employee,
  account,
  shift,
  holiday,
  division,
  attendance,
  shiftMaster,
  appealRequest,
  pendingRequest,
  testerDevice,
  userDevice,
  userActivity,
  userAttendance,
  userLeaveBalance,
  userLeaveHistory,
});
